import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';

import CircularProgress from '@mui/material/CircularProgress';

import BackButton from '@ts-core/components/BackButton';
import { useCourse } from 'modules/courses/hooks';

import AssignmentForm from '../../components/AssignmentForm';
import { useAssignmentActions } from '../../hooks';
import { AssignmentFormInput } from '../../types/form';

const NewAssignmentPage = () => {
  const history = useHistory();
  const intl = useIntl();
  const { courseId } = useParams<{ courseId: string }>();
  const { onCreateAssignment, createAssignmentLoading } = useAssignmentActions({ courseId });
  const { course } = useCourse({ courseId });

  const handleCreateAssignment = useCallback(
    (input: AssignmentFormInput) => {
      onCreateAssignment(input, (assignment) => {
        history.push(`/${courseId}/assignments/${assignment.id}/edit`);
      });
    },
    [courseId, history, onCreateAssignment]
  );

  if (!course) {
    return <CircularProgress />;
  }

  return (
    <>
      <BackButton
        title={intl.formatMessage({ id: 'assignment.createAssignment' })}
        subtitle={intl.formatMessage({ id: 'assignments' })}
        href={`/${courseId}/assignments`}
      />
      <AssignmentForm
        courseId={courseId}
        onSubmit={handleCreateAssignment}
        submitting={createAssignmentLoading}
        defaultNegativeValue={course.config.assignmentNegativeAnswerValue}
        defaultPositiveValue={course.config.assignmentPositiveAnswerValue}
        minScoreToShowSolutions={course.config.hideAssignmentSolutionBasedOnScore ? course.config.minScoreToShowAssignmenSolution : 0}
        hideSolutionsUntilDueDate={course.config.hideSolutionsUntilDueDate}
        allowPracticeOnlyAfterExpired={course.config.disablePracticeUntilDueDate}
      />
    </>
  );
};

export default NewAssignmentPage;
